import React from 'react';
import { Info } from 'lucide-react';

interface IsSharedFieldProps {
  isShared: boolean;
  onChange: (value: boolean) => void;
}

const IsSharedField: React.FC<IsSharedFieldProps> = ({ isShared, onChange }) => {
  return (
    <div className="space-y-2">
      <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
        Compartilhamento
      </label>

      <div className="flex items-start gap-3 p-4 bg-creme-light/50 rounded-lg border border-tinta/15">
        <input
          type="checkbox"
          id="isShared"
          checked={isShared}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 rounded border-tinta/30 text-bordo focus:ring-bordo/40 focus:ring-offset-0 cursor-pointer"
        />
        <div className="flex-1">
          <label htmlFor="isShared" className="text-sm font-bold text-tinta cursor-pointer">
            Permitir compartilhamento da roda
          </label>
          <p className="text-xs text-tinta-soft italic mt-1">
            Quando ativado, os usuários poderão compartilhar esta roda via redes sociais e WhatsApp
          </p>
        </div>
      </div>

      {!isShared && (
        <div className="flex items-start gap-2 bg-mostarda/15 border border-mostarda/40 rounded-lg p-3 text-sm text-tinta">
          <Info className="w-4 h-4 text-mostarda-dark flex-shrink-0 mt-0.5" />
          <p className="text-xs italic">
            Com o compartilhamento desativado, os botões de compartilhamento não aparecerão na roda
          </p>
        </div>
      )}
    </div>
  );
};

export default IsSharedField;
